export default __webpack_public_path__ + "static/media/explore11.f783c4c3.png";